import { resourceTypeEnabledAtom } from "@/modules/api/resourceTypes.tsx";
import { vmQueryAtom } from "@/modules/compute/vmQuery.ts";
import type { IpAssignableResource } from "@/modules/network/ipAddress/resourceId.ts";
import { lbQueryAtom } from "@/modules/network/loadbalancer/loadBalancerApi.ts";
import { allServicesQueryAtom } from "@/modules/services/servicesQuery.ts";
import { mergeQueryStatuses, type QMergedResult } from "@/utils/query/mergeQueries.ts";
import { atomFamily } from "jotai-family";
import { atom } from "jotai/vanilla";

export const ipAssignableQueryAtom = atomFamily((location: string) =>
    atom((get): QMergedResult<IpAssignableResource[]> => {
        const vms = get(resourceTypeEnabledAtom("virtual_machine")) ? get(vmQueryAtom(location)) : undefined;
        const balancers = get(resourceTypeEnabledAtom("load_balancer")) ? get(lbQueryAtom(location)) : undefined;
        const services = get(resourceTypeEnabledAtom("managed_service")) ? get(allServicesQueryAtom) : undefined;

        const servicesData = services?.data ? [...services.data.values()] : [];

        // Would use `mergeQueries` here, but the query can be `undefined` which it does not support
        return mergeQueryStatuses({ vms, balancers, services }, [
            ...(vms?.data?.values() ?? []),
            ...(balancers?.data?.values() ?? []),
            // NB: services are for all locations, need to add an extra filter here
            ...servicesData.filter((s) => s.location === location),
        ]);
    }),
);
